module.exports = __webpack_public_path__ + "img/serviceGuide-center-3.ae2d229.png";